import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { forkJoin } from 'rxjs';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from 'src/app/users/users.component';
import { EditorComponent } from 'src/app/editor/editor.component';

@Component({
  selector: 'app-form-template-users',
  templateUrl: './form-template-users.component.html',
  styleUrls: ['./form-template-users.component.scss'],
})
export class FormTemplateUsersComponent implements OnInit {
  @Input() data: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  formTemplateUsersList: any = [];
  formTemplateUsersListTemp: any = [];
  formTemplateUserData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  templateId: any;
  formId: any;
  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private snackBar: MatSnackBar,
    public paginationService: PaginationService,
    public message: messageService,
    private elem: ElementRef
  ) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  //page = 1;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = 'Showing results';
  displayingClaimsText = 'Displaying claims';
  rowText = 'Rows';
  showingRowsText = 'Showing rows';
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(
      this.formTemplateUsersList.length,
      page,
      this.perPage,
      targetpage
    );
    this.pagedItems = this.formTemplateUsersList.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    // if (page < 1 || page > this.pager.totalPages) {
    //   return;
    // }
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.formTemplateUsersListTemp.length > 0) {
      this.pager = this.paginationService.getPager(
        this.formTemplateUsersListTemp.length,
        page,
        this.perPage,
        targetpage
      );
      this.pagedItems = this.formTemplateUsersListTemp.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = [];
    }
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    //this.visibleviwerClobPopup = this.dialog.open(this.viwerClobPopup, this.aviwerlPopupConfig);
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    };
    this.htmlContent = '';
    console.log(this.columnLists);
    this.appService.getClobToViewAudit(docObj).subscribe(
      (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      },
      (error) => {
        console.log(error);
      }
    );
    this.isProcessing = false;
  }

  getcallMethod() {
    this.isProcessing = true;
    this.formTemplateUsersList = [];
    const data = {
      gridName:
        this.data.module == 'FORMS' ? 'FORM_USERS' : 'FORM_TEMPLATE_USERS',
    };
    this.appService.getDynamicGridHeaders(data).subscribe(
      (response: any) => {

        if (response.orderByClause == null) {
          response.orderByClause = '';
        }

        this.makeStickyColumns = response.fixedFieldCnt;

        let data1: any = {
          gridName:
            this.data.module == 'FORMS' ? 'FORM_USERS' : 'FORM_TEMPLATE_USERS',
          tableOrViewName:
            response.tableOrViewName == null
              ? ''
              : this.data.module == 'FORMS'
                ? 'ONEQMS_FORM_USERS_VW'
                : 'ONEQMS_FORM_TEMPLATE_USERS_VW',
          columnsList: response.columnsList == null ? '' : response.columnsList,
          fieldLabelsList:
            response.fieldLabelsList == null ? '' : response.fieldLabelsList,
          invisibleColumn:
            response.invisibleColumn == null ? '' : response.invisibleColumn,
          orderByClause:
            response.orderByClause == null ? '' : response.orderByClause,
          fieldSizeList:
            response.fieldSizeList == null ? '' : response.fieldSizeList,
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          templateIdFromQmsReportTemplate: this.templateId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || '',
          blobColumnlist: response.bloblist || '',
        };
        if (this.module == 'FORMS') {
          data1.formId = this.formId;
        } else {
          data1.formId = 0;
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe(
          (response1: any) => {
            this.formTemplateUsersList = response1;
            console.log('Data - ', this.formTemplateUsersList);
            data1.columnsListarray = data1.columnsList.split(',');
            data1.fieldColumnarray = data1.fieldLabelsList.split(',');
            data1.invisibleColumnarray = data1.invisibleColumn.split(',');
            data1.fieldSizeListArray = data1.fieldSizeList.split(',');
            let rendereddata: any;

            /* for(let i=0;i<response1.length;i++){
          this._temp={};
          for(let j=0;j<data1.columnsListarray.length;j++){
            let columnname=data1.columnsListarray[j];
            this._temp[columnname] = response1[i][j];
          }
          this.trainingParameterTemplateDataForGrid.push(this._temp);
        } */

            if (this.data.module == 'FORMS') {
              data1.invisibleColumnarray.push('ADD_FORM');
            } else {
              data1.invisibleColumnarray.push('HANDLE_FORM');
              data1.invisibleColumnarray.push('VERIFY_FORM_DATA');
              data1.invisibleColumnarray.push('FORM_NAME');
            }
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                fieldColumnarray: data1.fieldColumnarray[p],
                width: data1.fieldSizeListArray[p] + 'px',
              });
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (let w = 0; w < data1.fieldSizeListArray.length; w++) {
              this.columnLists.fieldSizeListArray.push(
                data1.fieldSizeListArray[w] + 'px'
              );
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (
                let k = 0;
                k < this.columnLists.invisibleColumnarray.length;
                k++
              ) {
                if (
                  this.columnLists.columnsListarray[y] ==
                  this.columnLists.invisibleColumnarray[k]
                ) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName,
            };
            this.columnLists.columnsListarray1 = [];
            this.appService
              .tableFieldsDataType(tableData)
              .subscribe((response2: any) => {
                //console.log(response2);
                this.dataTypeList = response2;
                for (
                  let m = 0;
                  m < this.columnLists.columnsListarray.length;
                  m++
                ) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray =
                    this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = 'textbox';
                  this.columnLists.columnsListarray1[m].width =
                    this.columnLists.fieldSizeListArray;
                  for (let w = 0; w < this.dataTypeList.length; w++) {
                    if (
                      this.dataTypeList[w].columnName ==
                      this.columnLists.columnsListarray[m]
                    ) {
                      this.columnLists.columnsListarray1[m].dataType =
                        this.dataTypeList[w].fieldType;
                    }
                  }
                }
                //console.log(this.columnLists.columnsListarray1);
                for (let i = 0; i < this.formTemplateUsersList.length; i++) {
                  for (let y = 0; y < this.dataTypeList.length; y++) {
                    if (this.dataTypeList[y].fieldType == 'CHECKBOX') {
                      this.formTemplateUsersList[i][
                        this.dataTypeList[y].columnName
                      ] =
                        this.formTemplateUsersList[i][
                          this.dataTypeList[y].columnName
                        ] == 'Y'
                          ? true
                          : false;
                    }
                  }
                }
                //this.trainingParameterTemplateDataForGrid=this.trainingParameterTemplateDataForGrid;
                this.calculateTotalPages = this.collectionSize / this.perPage;
                //console.log(this.trainingParameterTemplateDataForGrid);
                this.setPage(1, 0);
                this.pager.totalPages = undefined;
              });
            this.message.gridList = this.formTemplateUsersList;
            this.collectionSize = this.formTemplateUsersList.length;
            this.totalPages = Math.ceil(
              this.formTemplateUsersList.length / this.itemsPerPage
            );
            this.labelcall();
            //this.updateDisplayedData();
          },
          (error) => {
            this.isProcessing = false;
            throw error;
          }
        );
        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        throw error;
      }
    );
  }

  label: any = [];
  dynamicLabel: any = null;
  formsFieldLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data1 = {
      // tableName: 'ONEQMS_FORM_USERS_VW',
      tableName:
        this.data.module == 'FORMS'
          ? 'ONEQMS_FORM_USERS_VW'
          : 'ONEQMS_FORM_TEMPLATE_USERS_VW',
      moduleName: null,
      // gridName: 'FORM_USERS',
      gridName:
        this.data.module == 'FORMS' ? 'FORM_USERS' : 'FORM_TEMPLATE_USERS',
      groupId: 0,
    };

    let data2 = {
      tableName: 'ONEQMS_FORM_USERS_VW',
      moduleName: null,
      gridName: 'FORM_USERS',
      groupId: 0,
    };

    let tempData = this.appService.getreorderGirdColumnList(data1);
    /*     let formData = this.appService.getreorderGirdColumnList(data2);
     */ forkJoin([tempData]).subscribe(
      (result: any) => {
        this.isProcessing = false;
        let label = result[0];
        this.dynamicLabel = label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});

        /*  let label2 = result[1];
       this.formsFieldLabel = label2.reduce((acc:any, user:any) => {
         acc[`${user.columnName}`] = user.changedFieldName;
         return acc;
       }, {}); */
        console.log('FL', this.formsFieldLabel);
        console.log('DY', this.dynamicLabel);
      },
      (error: any) => {
        this.isProcessing = false;
      }
    );
  }

  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dropDownForInvisibleSections: any = [];
  dropDownForInvisibleFields: any = [];
  ngOnInit() {
    this.dropDownForDesignationCode = JSON.parse(
      sessionStorage.getItem('dropDownForDesignationCode') || '{}'
    );
    this.dropDownForDepartmentCode = JSON.parse(
      sessionStorage.getItem('dropDownForDepartmentCode') || '{}'
    );
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    if (this.data) {
      this.templateId = this.data.templateId;
      this.module = this.data.module;
      if (this.data.module == 'FORMS') {
        this.formId = this.data.formId;
      }
    }
    this.getcallMethod();
    this.appService
      .getFormSectionTemplateList(
        this.data.templateId
      )
      .subscribe((data: any) => {
        this.dropDownForInvisibleSections = data;
      });
    this.appService
      .getFieldsListByTemplateId(

        this.data.templateId
      )
      .subscribe((data: any) => {
        this.dropDownForInvisibleFields = data;
      });
  }
  module: any;

  // ngAfterViewInit() {

  // }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    if (filter === '') {
      this.pagedItems = this.formTemplateUsersList.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = this.formTemplateUsersList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.formTemplateUsersListTemp = this.formTemplateUsersList;
      this.pager = this.paginationService.getPager(
        this.formTemplateUsersListTemp.length,
        1,
        this.perPage,
        0
      );
      this.pagedItems = this.formTemplateUsersListTemp.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      /* this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid.filter((item: { subject: string; date: { toString: () => string | string[]; }; }) =>
        item.subject?.toLowerCase().includes(filter) ||
        item.date?.toString().includes(filter)
      ); */
      if (this.formTemplateUsersList == undefined) {
        return this.formTemplateUsersList;
      }
      if (!this.formTemplateUsersList.length) {
        return this.formTemplateUsersList;
      }
      if (filter != undefined) {
        this.formTemplateUsersListTemp = this.formTemplateUsersList.filter(
          function (item: any) {
            return JSON.stringify(item).toLowerCase().includes(filter);
          }
        );
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;
      } else {
        this.formTemplateUsersListTemp = this.formTemplateUsersList.filter(
          function (item: any) {
            return JSON.stringify(item).toLowerCase();
          }
        );
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.formTemplateUsersList.sort(
      (a: { [x: string]: any }, b: { [x: string]: any }) => {
        const key = column as string;
        const valueA = a[key];
        const valueB = b[key];

        if (valueA! < valueB!) {
          return this.sortDirection === 'asc' ? -1 : 1;
        } else if (valueA! > valueB!) {
          return this.sortDirection === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
    );
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-col1'
    );
    let index1 = 1;
    //let stickycount = 4;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            let previousColumn = elements1[key - 1];
            //console.log(previousColumn.style.offsetWidth);
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    });

    let elements2 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-row1'
    );
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background =
            keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = 'underline';
          column.style.color = 'blue';
          column.style.cursor = 'pointer';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          //column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == lengthOfColumns - 1) {
        index2 = 0;
      } else {
        index2++;
      }
    });
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.formTemplateUsersList.length; p++) {
        this.formTemplateUsersList[p].childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.formTemplateUsersList.length; p++) {
        this.formTemplateUsersList[p].childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.formTemplateUsersList[this.priviousSelectedValue].childCheckBoxs =
          false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  userName: any;
  userNameRequiredMsg: any;
  updateReasonForusers: any;
  updateReasonForusersMsg: any;
  fieldValidation(): boolean {
    let isValid = true;

    this.userName = document.getElementById('userName') as HTMLInputElement;
    this.userNameRequiredMsg = document.getElementById('userName-required-msg') as HTMLSpanElement;

    this.updateReasonForusers = document.getElementById('user-comments') as HTMLInputElement;
    this.updateReasonForusersMsg = document.getElementById('update-required-msg') as HTMLSpanElement;

    // ✅ validate username
    if (!this.formTemplateUserData.userName) {
      this.userName.classList.add('error');
      this.userNameRequiredMsg.style.display = 'block';
      isValid = false;
    } else {
      this.userName.classList.remove('error');
      this.userNameRequiredMsg.style.display = 'none';
    }

    // ✅ validate updateReason only when visibleEditButton = true
    if (this.visibleEditButton) {
      if (!this.formTemplateUserData.comments) {
        this.updateReasonForusers.classList.add('error');
        this.updateReasonForusersMsg.style.display = 'block';
        isValid = false;
      } else {
        this.updateReasonForusers.classList.remove('error');
        this.updateReasonForusersMsg.style.display = 'none';
      }
    }

    return isValid;
  }


  onFieldFocusout() {
    if (this.userNameRequiredMsg != undefined) {
      this.userName.style.border = 'none';
      this.userNameRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  operationFlag: any;
  popupDataTitle: PopupData = {
    title: '',
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true })
  addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchUserPopup', { static: true })
  searchUserPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  searchUserPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = 'Create User';
    this.formTemplateUserData = {};
    this.formTemplateUserData.userName = '';
    this.formTemplateUserData.userId = null;
    this.formTemplateUserData.addForm1 = true;
    this.formTemplateUserData.handleForm1 = false;
    this.formTemplateUserData.verifyFormData1 = false;
    this.formTemplateUserData.withdrawFormData1 = false;
    this.formTemplateUserData.comments = null;
    this.formTemplateUserData.invisibleFormSections = null;
    this.formTemplateUserData.invisibleFormSectionsList = [];
    this.formTemplateUserData.invisibleFormSectionFields = null;
    this.formTemplateUserData.invisibleFormSectionFieldsList = [];
    this.formTemplateUserData.noneditableFormSectionFields = null;
    this.formTemplateUserData.noneditableFormSectionFieldsList = [];
    this.formTemplateUserData.switchUserAccess1 = false;
    this.formTemplateUserData.submitForVerification1 = false;
    this.formTemplateUserData.submitForWithdraw1 = false;
    this.formTemplateUserData.selfAssignAccess1 = true;
    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );
  }

  openEditPopup(user: any) {
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = 'Update User';
    this.formTemplateUserData = user;
    this.formTemplateUserData.comments = '';
    this.isProcessing = true;
    this.appService
      .getFormUsersByUserId(
        user.TEMPLATE_ID,
        user.FORM_ID,
        user.USER_ID
      )
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.formTemplateUserData = data[0];
        this.formTemplateUserData.module = this.data.module;
        this.formTemplateUserData.addForm1 =
          this.formTemplateUserData.addForm == 'Y' ? true : false;
        this.formTemplateUserData.handleForm1 =
          this.formTemplateUserData.handleForm == 'Y' ? true : false;
        this.formTemplateUserData.verifyFormData1 =
          this.formTemplateUserData.verifyFormData == 'Y' ? true : false;
        this.formTemplateUserData.withdrawFormData1 =
          this.formTemplateUserData.withdrawFormData == 'Y' ? true : false;
        this.formTemplateUserData.switchUserAccess1 =
          this.formTemplateUserData.switchUserAccess == 'Y' ? true : false;
        this.formTemplateUserData.submitForWithdraw1 =
          this.formTemplateUserData.submitForWithdraw == 'Y' ? true : false;
        this.formTemplateUserData.submitForVerification1 =
          this.formTemplateUserData.submitForVerification == 'Y' ? true : false;
        this.formTemplateUserData.selfAssignAccess1 =
          this.formTemplateUserData.selfAssignAccess == 'Y' ? true : false;
        this.formTemplateUserData.invisibleFormSectionsList = [];
        this.formTemplateUserData.invisibleFormSectionFieldsList = [];
        this.formTemplateUserData.noneditableFormSectionFieldsList = [];
        this.formTemplateUserData.comments = '';
        if (this.formTemplateUserData.invisibleFormSections != null) {
          this.formTemplateUserData.invisibleFormSectionsList =
            this.formTemplateUserData.invisibleFormSections
              .split(',')
              .map(Number);
          setTimeout(() => {
            this.isAllInvisibleSectionSelected =
              this.dropDownForInvisibleSections.length ==
              this.formTemplateUserData.invisibleFormSectionsList.length;
          });
        }
        if (this.formTemplateUserData.invisibleFormSectionFields != null) {
          this.formTemplateUserData.invisibleFormSectionFieldsList =
            this.formTemplateUserData.invisibleFormSectionFields
              .split(',')
              .map(Number);
          setTimeout(() => {
            this.isAllInvisibleSectionFieldsSelected =
              this.dropDownForInvisibleFields.length ==
              this.formTemplateUserData.invisibleFormSectionFieldsList.length;
          });
        }
        if (this.formTemplateUserData.noneditableFormSectionFields != null) {
          this.formTemplateUserData.noneditableFormSectionFieldsList =
            this.formTemplateUserData.noneditableFormSectionFields
              .split(',')
              .map(Number);
          setTimeout(() => {
            this.isAllNoneditableSectionFieldsSelected =
              this.dropDownForInvisibleFields.length ==
              this.formTemplateUserData.noneditableFormSectionFieldsList.length;
          });
        }
      });
    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );
  }

  refreshGridData() {
    this.getcallMethod();
  }

  addAndEditFunction(formTemplateUser: any) {
    this.isProcessing = true;
    if (!this.fieldValidation()) {
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {
        let data: any = {};

        data.templateId = this.data.templateId;

        data.comments = formTemplateUser.comments;
        data.usersList = this.selectedUserIdList;
        if (this.data.module == 'FORMS') {
          data.handleForm = formTemplateUser.handleForm1 ? 'Y' : 'N';
          data.verifyFormData = formTemplateUser.verifyFormData1 ? 'Y' : 'N';
          data.withdrawFormData = formTemplateUser.withdrawFormData1 ? 'Y' : 'N';
          data.switchUserAccess = formTemplateUser.switchUserAccess1 ? 'Y' : 'N';
          data.submitForWithdraw =
            formTemplateUser.submitForWithdraw1 ? 'Y' : 'N';
          data.submitForVerification =
            formTemplateUser.submitForVerification1 ? 'Y' : 'N';
          data.selfAssignAccess = formTemplateUser.selfAssignAccess1 ? 'Y' : 'N';
          data.addForm = 'N';
          data.formId = this.data.formId;
          data.invisibleFormSections = null;
          data.invisibleFormSectionFields = null;
          data.noneditableFormSectionFields = null;
          if (formTemplateUser.invisibleFormSectionsList.length > 0) {
            data.invisibleFormSections =
              formTemplateUser.invisibleFormSectionsList.join(',');
          }
          if (formTemplateUser.invisibleFormSectionFieldsList.length > 0) {
            data.invisibleFormSectionFields =
              formTemplateUser.invisibleFormSectionFieldsList.join(',');
          }
          if (formTemplateUser.noneditableFormSectionFieldsList.length > 0) {
            data.noneditableFormSectionFields =
              formTemplateUser.noneditableFormSectionFieldsList.join(',');
          }
        } else {
          data.formId = 0;
          data.addForm = formTemplateUser.addForm1 ? 'Y' : 'N';
        }

        this.appService.createFormTemplateUser(data).subscribe(
          (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(
              SuccessSnackbarComponent,
              {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: 'Ok',
                  pageName:
                    this.message.breadcrumbData.thirdLevel == null
                      ? this.message.breadcrumbData.secondLevel
                      : this.message.breadcrumbData.thirdLevel,
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              }
            );
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          },
          (error) => {
            this.isProcessing = false;
            throw error;
          }
        );
      } else {
        delete formTemplateUser.createdOn;
        delete formTemplateUser.updatedOn;


        formTemplateUser.addForm = formTemplateUser.addForm1 ? 'Y' : 'N';
        if (this.data.module == 'FORMS') {
          formTemplateUser.handleForm = formTemplateUser.handleForm1 ? 'Y' : 'N';
          formTemplateUser.verifyFormData = formTemplateUser.verifyFormData1 ? 'Y' : 'N';
          formTemplateUser.withdrawFormData = formTemplateUser.withdrawFormData1 ? 'Y' : 'N';
          formTemplateUser.switchUserAccess =
            formTemplateUser.switchUserAccess1 ? 'Y' : 'N';

          formTemplateUser.submitForWithdraw =
            formTemplateUser.submitForWithdraw1 ? 'Y' : 'N';
          formTemplateUser.submitForVerification =
            formTemplateUser.submitForVerification1 ? 'Y' : 'N';
          formTemplateUser.selfAssignAccess =
            formTemplateUser.selfAssignAccess1 ? 'Y' : 'N';
          formTemplateUser.invisibleFormSections = null;
          formTemplateUser.invisibleFormSectionFields = null;
          formTemplateUser.noneditableFormSectionFields = null;
          if (formTemplateUser.invisibleFormSectionsList.length > 0) {
            formTemplateUser.invisibleFormSections =
              formTemplateUser.invisibleFormSectionsList.join(',');
          }
          if (formTemplateUser.invisibleFormSectionFieldsList.length > 0) {
            formTemplateUser.invisibleFormSectionFields =
              formTemplateUser.invisibleFormSectionFieldsList.join(',');
          }
          if (formTemplateUser.noneditableFormSectionFieldsList.length > 0) {
            formTemplateUser.noneditableFormSectionFields =
              formTemplateUser.noneditableFormSectionFieldsList.join(',');
          }
        }
        this.appService.updateFormTemplateUser(formTemplateUser).subscribe(
          (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(
              SuccessSnackbarComponent,
              {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: 'Ok',
                  pageName:
                    this.message.breadcrumbData.thirdLevel == null
                      ? this.message.breadcrumbData.secondLevel
                      : this.message.breadcrumbData.thirdLevel,
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              }
            );
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = true;
          },
          (error) => {
            this.isProcessing = false;
            throw error;
          }
        );
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById(
      'deleteTextarea-required-msg'
    ) as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFormSectionTemplateTemplateId: any;
  openDeletePopup(deleteRowData: any) {
    this.formTemplateUserData = deleteRowData;
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = 'Delete Form Template User';
    this.deleteFormSectionTemplateTemplateId = deleteRowData.SECTION_ID;
    if (this.formTemplateUserData.deleteReason != undefined) {
      this.formTemplateUserData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(
      this.deletePopup,
      this.deletePopupConfig
    );
  }

  deleteFormTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById(
      'deleteTextarea'
    ) as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        templateId: this.data.templateId,
        formId: this.formTemplateUserData.FORM_ID,
        deleteReason: this.formTemplateUserData.deleteReason,
        userId: this.formTemplateUserData.USER_ID,
      };
      this.appService.deleteFormTemplateUser(data).subscribe(
        (Response: any) => {
          if (Response.resultType == 'S') {
            this.getcallMethod();
            this.visibleDeletePopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok',
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        },
        (error) => {
          this.isProcessing = false;
          throw error;
        }
      );
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  goToDetailPage(editRowData: any) { }

  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    //console.log(e);
    if (e.target.checked == true) {
      //this.searchManagerChildCheckBoxs = true;
      //this.searchManagerChildCheckBoxsMenu=true;
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs =
          true;
        this.selectedUserIdList.push(
          this.getOneQmsUsersVwDetailsTableData[k].userId
        );
        this.selectedUserNameList.push(
          this.getOneQmsUsersVwDetailsTableData[k].userName
        );
      }
    } else {
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs =
          false;
        this.selectedUserIdList = [];
        this.selectedUserNameList = [];
      }
      //this.searchManagerChildCheckBoxs = false;
      //this.searchManagerChildCheckBoxsMenu=false;
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: String;
  selectedUserIdList: any = [];
  selectedUserNameList: any = [];
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    // console.log(e);
    //console.log(listOfUsersVwDetails);
    //console.log(idx);

    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      //this.getSelectedUserId = listOfUsersVwDetails.userId;
      //this.getSelectedUserName = listOfUsersVwDetails.userName;
      this.selectedUserIdList.push(listOfUsersVwDetails.userId);
      this.selectedUserNameList.push(listOfUsersVwDetails.userName);
    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
      this.selectedUserIdList.splice(
        this.selectedUserIdList.indexOf(listOfUsersVwDetails.userId),
        1
      );
      this.selectedUserNameList.splice(
        this.selectedUserNameList.indexOf(listOfUsersVwDetails.userName),
        1
      );
    }
  }

  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  showUserSearchGrid: any;
  searchUserFunction() {
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.selectedUserIdList = [];
    this.selectedUserNameList = [];
    this.formTemplateUserData.userId = null;
    this.formTemplateUserData.userName = null;
    //this.popupDataTitle.title = "Search Trainer";
    this.visibleSearchUserPopup = this.dialog.open(
      this.searchUserPopup,
      this.searchUserPopupConfig
    );
  }

  addUserNameFunction() {
    for (let i = 0; i < this.selectedUserIdList.length; i++) {
      if (this.formTemplateUserData.userId == null) {
        this.formTemplateUserData.userId = this.selectedUserIdList[i];
      } else {
        this.formTemplateUserData.userId =
          this.formTemplateUserData.userId + ',' + this.selectedUserIdList[i];
      }
    }
    for (let i = 0; i < this.selectedUserNameList.length; i++) {
      if (
        this.formTemplateUserData.userName == null ||
        this.formTemplateUserData.userName == undefined
      ) {
        this.formTemplateUserData.userName = this.selectedUserNameList[i];
      } else {
        this.formTemplateUserData.userName =
          this.formTemplateUserData.userName +
          ',' +
          this.selectedUserNameList[i];
      }
    }

    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByDesignationCode) {
      this.designationCodeValue = this.searchByDesignationCode;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode) {
      this.departmentCodeValue = this.searchByDepartmentCode;
    } else {
      this.departmentCodeValue = null;
    }
    let searchByUserName;
    if (this.searchByUserName != null) {
      searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      groupId: 0,
    };
    this.appService
      .getFormTemplateUsersList(this.searchOneQmsUserVwDetails)
      .subscribe((response: any) => {
        this.getOneQmsUsersVwDetailsTableData = response;
        this.showUserSearchGrid = true;
        this.isProcessing = false;
        //console.log(this.getOneQmsUsersVwDetailsTableData);
      });
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  onInvlisibleSectionSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.invisibleFormSectionsList
        );
        this.isAllInvisibleSectionSelected =
          this.dropDownForInvisibleSections.length ==
          this.formTemplateUserData.invisibleFormSectionsList.length;
      });
  }

  onInvlisibleSectionFeildSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.invisibleFormSectionFieldsList
        );
        this.isAllInvisibleSectionFieldsSelected =
          this.dropDownForInvisibleFields.length ==
          this.formTemplateUserData.invisibleFormSectionFieldsList.length;
      });
  }

  onNoneditableSectionFieldsSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.noneditableFormSectionFieldsList
        );
        this.isAllNoneditableSectionFieldsSelected =
          this.dropDownForInvisibleFields.length ==
          this.formTemplateUserData.noneditableFormSectionFieldsList.length;
      });
  }

  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = fieldId === 'execution-validation';
    const shouldBeRed = isMultiSelectValidation
      ? !selectedItems.length
      : !selectedItems;

    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0);
  }

  invisibleSectionSearchText: string = '';
  invisibleSectionFieldsSearchText: string = '';
  noneditableSectionFieldsSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0);
  }

  @ViewChild('invisibleSections') invisibleSections: MatSelect;
  isAllInvisibleSectionSelected = false;
  @ViewChild('invisibleSectionFields') invisibleSectionFields: MatSelect;
  isAllInvisibleSectionFieldsSelected = false;

  @ViewChild('noneditableSectionFields') noneditableSectionFields: MatSelect;
  isAllNoneditableSectionFieldsSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'invisibleSections') {
      if (this.isAllInvisibleSectionSelected)
        this.invisibleSections.options.forEach((item: MatOption) =>
          item.select()
        );
      else {
        this.invisibleSections.options.forEach((item: MatOption) =>
          item.deselect()
        );
        this.formTemplateUserData.invisibleFormSectionsList = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.invisibleFormSectionsList
        );
      });
    } else if (value == 'invisibleSectionFields') {
      if (this.isAllInvisibleSectionFieldsSelected)
        this.invisibleSectionFields.options.forEach((item: MatOption) =>
          item.select()
        );
      else {
        this.invisibleSectionFields.options.forEach((item: MatOption) =>
          item.deselect()
        );
        this.formTemplateUserData.invisibleFormSectionFieldsList = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.invisibleFormSectionFieldsList
        );
      });
    } else if (value == 'noneditableSectionFields') {
      if (this.isAllNoneditableSectionFieldsSelected)
        this.noneditableSectionFields.options.forEach((item: MatOption) =>
          item.select()
        );
      else {
        this.noneditableSectionFields.options.forEach((item: MatOption) =>
          item.deselect()
        );
        this.formTemplateUserData.noneditableFormSectionFieldsList = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation(
          'execution-validation',
          this.formTemplateUserData.noneditableFormSectionFieldsList
        );
      });
    }
  }

  selectBoxeForDesignationCode() {
    for (let i = 0; i < this.dropDownForDesignationCode.length; i++) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: this.dropDownForDesignationCode[i].codelistCode,
        displayExp: this.dropDownForDesignationCode[i].codelistName,
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (let i = 0; i < this.dropDownForDepartmentCode.length; i++) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: this.dropDownForDepartmentCode[i].codelistCode,
        displayExp: this.dropDownForDepartmentCode[i].codelistName,
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;

  designationsearchTxt: any;

  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDesignationValue = item.valueExp;
      } else {
        this.selectedDesignationValue = undefined;
      }
    }
  }

  departmentsearchTxt: any;

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValue = item.valueExp;
      } else {
        this.selectedDepartmentValue = undefined;
      }
    }
  }
  @ViewChild(DynamicAuditTrailComponent)
  dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openAuditTrail(viewType: any, user: any) {
    this.auditTrail.form_TemplateId_Audit_Trail = this.data.templateId;
    this.auditTrail.formId_Audit_Trail =
      this.data.module == 'FORMS' ? this.data.formId : 1;
    this.auditTrail.refNo = viewType == 'overAll' ? null : user.USER_ID;
    this.auditTrail.gridName =
      this.data.module == 'FORMS' ? 'FORM_USERS' : 'FORM_TEMPLATE_USERS';
    this.auditTrail.report_And_Popup_Name = 'Forms Users Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(user);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Forms Users Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map(
      (item: any) => item.fieldColumnarray
    );
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(
      this.data.module == 'FORMS' ? 'FORM_USERS' : 'FORM_TEMPLATE_USERS',
      this.data.module == 'FORMS'
        ? 'ONEQMS_FORM_USERS_VW'
        : 'ONEQMS_FORM_TEMPLATE_USERS_VW',
      null,
      0
    );
  }

  onChildValueEmitted() {
    this.getcallMethod();
  }
}
